/**
 * 常使用之基礎url字串
 * @readonly
 * @enum {string}
 */
enum url$ {
    login = 'login',
    /** 系統初始 */
    app = 'api/app/',
    /** 驗證身份 */
    auth = 'api/secret/',
    /** 手動觸發排程 */
    schedule = 'api/schedule/',
    /** Demo */
    demo = 'api/demo/',
    /** WebRTC */
    webrtc = 'api/webrtc/'
}

export default url$;